import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

const images = [
  {
    src: 'https://firebasestorage.googleapis.com/v0/b/peyen-de088.firebasestorage.app/o/traduccion.jpg?alt=media&token=cc18ee11-1352-4e28-9f72-3f3e8dcf1cf7',
    title: 'Traducción Simultánea',
  },
  {
    src: 'https://firebasestorage.googleapis.com/v0/b/peyen-de088.firebasestorage.app/o/Sonido.jpg?alt=media&token=cb7b50c5-0086-483f-afc1-04d02734cdd8',
    title: 'Sonido Profesional',
  },
  {
    src: 'https://firebasestorage.googleapis.com/v0/b/peyen-de088.firebasestorage.app/o/Proyeccion.jpg?alt=media&token=587d3618-e419-4ecd-80dd-4d6ee269b250',
    title: 'Proyección HD',
  },
  {
    src: 'https://firebasestorage.googleapis.com/v0/b/peyen-de088.firebasestorage.app/o/pantalla%20led.jpg?alt=media&token=f78118b5-ea6c-4e7c-8d23-814ea06c8d16',
    title: 'Pantallas LED',
  },
];

const ImageCarousel = () => {
  return (
    // SECCIÓN CONTENEDORA: Aquí controlamos el ancho y el padding exterior
    <section className="bg-slate-50 py-16 px-6">
      <div className="max-w-6xl mx-auto overflow-hidden rounded-3xl shadow-2xl border border-white">
        
        <Swiper
          modules={[Navigation, Pagination, Autoplay, EffectFade]}
          effect={'fade'} // Cambiado a 'fade' para transiciones suaves
          loop={true}
          navigation={true}
          pagination={{ clickable: true, dynamicBullets: true }}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          
          // ESTO ES CLAVE: Definimos la proporción responsiva
          className="aspect-[21/9] w-full"
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <div className="relative w-full h-full">
                <img
                  src={image.src}
                  alt={image.title}
                  //object-cover es crucial para que la imagen se adapte sin deformarse
                  className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                />
                
                {/* Degradado oscuro sutil para que el texto sea legible */}
                <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/70 to-transparent"></div>
                
                {/* Texto superpuesto */}
                <div className="absolute bottom-6 left-6 p-4">
                  <span className="inline-block bg-blue-100 text-blue-800 text-xs px-3 py-1 rounded-full font-semibold mb-2">
                    Nuestros Servicios
                  </span>
                  <h3 className="text-2xl md:text-3xl font-extrabold text-white">
                    {image.title}
                  </h3>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ImageCarousel;
